module.exports = __webpack_public_path__ + "static/img/W.92295fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hjzs/W.png
// module id = avSP
// module chunks = 0